import { enGB, de, fr, it, itCH, deAT } from 'date-fns/locale'

export const getLocale = (i18nLanguage: string) => {
    switch (i18nLanguage) {
        case 'en':
            return enGB
        case 'de':
            return de
        case 'fr':
            return fr
        case 'it':
            return it
        case 'it-CH':
            return itCH
        case 'de-AT':
            return deAT
        case 'de-CH':
            return de
        default:
            return enGB
    }
}
